import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import {
  toggleItemType,
  setItemTypeActive,
  setAllItemTypesActive,
  initializeItemTypes,
} from "./itemTypePreferencesSlice";
import { itemTypeService } from "../../services/almanac";
import type { RootState } from "../../store";
import type { ItemTypePreferences } from "./itemTypePreferencesSlice";

const STORAGE_KEY = "itemTypePreferences";

const saveToLocalStorage = (state: ItemTypePreferences) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (error) {
    console.warn("Failed to save item type preferences to localStorage:", error);
  }
};

export const itemTypePreferencesListener = createListenerMiddleware();

// Listen for item type preference changes and save to localStorage
itemTypePreferencesListener.startListening({
  matcher: isAnyOf(
    toggleItemType,
    setItemTypeActive,
    setAllItemTypesActive,
    initializeItemTypes,
  ),
  effect: async (_action, listenerApi) => {
    // Wait for the state to be updated
    await listenerApi.delay(0);

    // Get the current state
    const state = listenerApi.getState() as RootState;
    const itemTypePreferences = state.itemTypePreferences;

    // Save to localStorage
    saveToLocalStorage(itemTypePreferences);
  },
});

// Listen for item type service data changes and auto-initialize preferences
itemTypePreferencesListener.startListening({
  matcher: itemTypeService.endpoints.getItemTypes.matchFulfilled,
  effect: (action, listenerApi) => {
    const itemTypes = action.payload;

    if (itemTypes && itemTypes.length > 0) {
      const itemTypeIds = itemTypes.map((itemType) => itemType.id);

      // Dispatch initialize action
      listenerApi.dispatch(initializeItemTypes(itemTypeIds));
    }
  },
});
